﻿export const supervisionCompany = (function () {
    class Company {
        constructor(id, name, cityId, currencyId, isDelete, latestActivity,
            registrationDate, ownerId, phone, tariffId) {
            this.id = id;
            this.name = name;
            this.cityId = cityId;
            this.currencyId = currencyId;
            this.isDelete = isDelete;
            this.latestActivity = latestActivity;
            this.registrationDate = registrationDate;
            this.ownerId = ownerId;
            this.phone = phone;
            this.tariffId = tariffId;
        }
    }

    class Owner {
        constructor(id, name, email, isActive) {
            this.id = id;
            this.name = name;
            this.email = email;
            this.isActive = isActive;
        }
    }

    const company = new Company();
    const owner = new Owner();
    const url = "/supervisionApi";
    const method = 'POST';
    let countries = [];
    let tariffList;
    let periodList;
    let cities = [];
    let tariff;
    let currentRegion;
    let currentCountry;
    let currentCity;

    let tariffSelected;
    let periodSelected;

    const elements = {
        companyNameInput: document.getElementById('companyName'),
        companyOwnerNameInput: document.getElementById('companyOwnerName'),
        companyOwnerEmailInput: document.getElementById('companyOwnerEmail'),
        companyPhoneInput: document.getElementById('companyPhone'),
        companyCountrySelect: document.getElementById('companyCountry'),
        companyCityInput: document.getElementById('companyCity'),
        companyOtherTextarea: document.getElementById('companyOther'),
        companyRegistrationDate: document.getElementById('companyRegistrationDate'),
        companyLatestActivity: document.getElementById('companyLatestActivity'),
        tariffStartInput: document.getElementById('tariffStart'),
        tariffEndInput: document.getElementById('tariffEnd'),
        tariffList: document.getElementById('tariffList'),
        periodList: document.getElementById('tariffPeriod')
    };

    const toolbar = {
        block: document.querySelector('.toolbar-inner'),
        buttons: {
            save: document.querySelector('.supervisorCompany-save'),
        },

        tariffSaveAdd() {
            const toolbarTariffSave = document.createElement('a');
            toolbarTariffSave.classList.add('supervisionCompany-tariffSave');
            toolbarTariffSave.textContent = 'Изменить тариф';

            toolbar.buttons['tariffSave'] = toolbarTariffSave;
            toolbar.buttons.tariffSave.addEventListener('click', async function () {
                await tariffSet(company.id, tariffSelected, periodSelected);
                await new tariffs.CurrentTariff().get(company.id).then(result => {
                    tariff = result;
                })
                pageUpdate();
            });
        }
    };

    function companyIdGet() {
        if (company.Id === undefined) {
            company['Id'] = +ppUtils.browser.getQueryVariable('companyId');
        }

        return company.Id;
    };

    async function save() {
        company['Id'] = +ppUtils.browser.getQueryVariable('companyId');
        const outJson = {
            action: 'save',
            data: {
                companyId: companyId
            }
        };
        let response = await fetch(url, {
            method,
            headers: {
                'Content-Type': 'application/json;charset=utf-8'
            },
            body: JSON.stringify(outJson)
        });
        let results = await response.json();

        return results;
    };

    async function tariffSet(companyId, tariffId, periodId) {
        const outJson = {
            action: 'tariffSet',
            data: {
                companyId,
                tariffId,
                periodId
            }
        };
        let response = await fetch(url, {
            method,
            headers: {
                'Content-Type': 'application/json;charset=utf-8'
            },
            body: JSON.stringify(outJson)
        });
        let results = await response.json();

        return results;
    };

    // Загрузка компании
    async function companyLoad() {
        const outJson = {
            action: 'companyLoad',
            data: {
                companyId: company.Id
            }
        };
        const response = await fetch(url, {
            method,
            headers: {
                'Content-Type': 'application/json;charset=utf-8'
            },
            body: JSON.stringify(outJson)
        });

        const results = await response.json();
        company.id = results.Id;
        company.name = results.Name;
        company.cityId = results.CityId;
        company.currencyId = results.CurrencyId;
        company.isDelete = results.Delete;
        company.latestActivity = new Date(parseInt(/-?\d+/.exec(results.LatestActivity)[0]));
        company.registrationDate = new Date(parseInt(/-?\d+/.exec(results.RegistrationDate)[0]));
        company.ownerId = results.OwnerId;
        company.phone = results.Phone;
        company.tariffId = results.TariffId;

        return company;
    };

    async function ownerLoad() {
        const outJson = {
            action: 'ownerLoad',
            data: {
                companyId: company.id,
                ownerId: company.ownerId
            }
        };
        const response = await fetch(url, {
            method,
            headers: {
                'Content-Type': 'application/json;charset=utf-8'
            },
            body: JSON.stringify(outJson)
        });

        const results = await response.json();
        owner.id = results.ID;
        owner.name = results.SelfInfo.Name;
        owner.email = results.SelfInfo.Email;
        owner.isActive = results.SelfInfo.IsActive;

        return owner;
    };

    function companyGet() {
        return company;
    };

    function ownerGet() {
        return owner;
    };

    // update page elements
    function pageUpdate() {
        elements.companyNameInput.value = company.name;
        elements.companyOwnerNameInput.value = owner.name;
        elements.companyOwnerEmailInput.value = owner.email;
        elements.companyPhoneInput.value = company.phone;
        elements.companyRegistrationDate.value = company.registrationDate;
        elements.companyLatestActivity.value = company.latestActivity;
        elements.companyCountrySelect.innerHTML = '';
        elements.tariffList.innerHTML = '';
        elements.periodList.innerHTML = '';
        elements.tariffStartInput.value = tariff.start;
        elements.tariffEndInput.value = tariff.end;

        {
            const option = document.createElement('option');
            option.value = 0;
            option.textContent = 'Не выбрана';
            elements.companyCountrySelect.append(option)
        }

        for (const index in countries) {
            const option = document.createElement('option');
            option.value = countries[index].Id;
            option.textContent = countries[index].Name;

            if (countries[index].Id == currentCountry.Id) {
                option.setAttribute('selected', 'selected');
            }

            elements.companyCountrySelect.append(option);
        }

        for (const index in tariffList) {
            const option = document.createElement('option');
            option.value = tariffList[index].id;
            option.textContent = tariffList[index].name;

            if (tariffList[index].id == tariffSelected) {
                option.setAttribute('selected', 'selected');
            }

            elements.tariffList.append(option);
        }

        const periods = periodList.filter(item => (item.tariffId == tariffSelected));

        for (const index in periods) {

            const option = document.createElement('option');
            option.value = periods[index].id;
            option.textContent = periods[index].month;

            if (index == 0 && periodSelected === undefined) {
                periodSelected = periods[index].id;
            }

            if (periods[index].id == periodSelected) {
                option.setAttribute('selected', 'selected');
            }

            elements.periodList.append(option);
        }

        elements.companyCityInput.value = currentCity.Name;
    };

    // page initialization
    function pageInit(newCompany = false) {
        elements.companyNameInput.setAttribute('placeholder', 'ПрайсПро');
        elements.companyOwnerNameInput.setAttribute('placeholder',
            'Иванов Иван');
        elements.companyOwnerEmailInput.setAttribute('placeholder',
            'example@pricepro.online');
        elements.companyPhoneInput.setAttribute('placeholder',
            '+7(999)1234567');
        elements.companyCityInput.setAttribute('placeholder',
            'Введите название города...');

        elements.companyNameInput.removeAttribute('disabled');
        elements.companyPhoneInput.removeAttribute('disabled');
        elements.companyNameInput.removeAttribute('disabled');
        elements.companyOtherTextarea.removeAttribute('disabled');

        if (newCompany !== undefined && !newCompany) {
            elements.companyOwnerNameInput.removeAttribute('disabled');
            elements.companyOwnerEmailInput.removeAttribute('disabled');
        }

        toolbar.tariffSaveAdd();
        toolbar.block.append(toolbar.buttons.tariffSave);
    };

    // main
    async function main() {
        const companyId = companyIdGet();

        if (companyId && typeof (companyId) === 'number' &&
            companyId !== NaN) {
            await companyLoad().then(result => {
                tariffSelected = result.tariffId;
            });
            await Promise.all([
                ownerLoad(),
                locations.countriesGet().then(result => {
                    countries = result;
                }),
                new tariffs.CurrentTariff().get(company.id).then(result => {
                    tariff = result;
                }),
                tariffs.tariffsGet().then(results => {
                    tariffList = results;
                }),
                tariffs.periodsGet().then(results => {
                    periodList = results;
                })
            ]);

            pageInit();

            currentCity = await locations.cityGet(companyGet().cityId);
            currentRegion = await locations.regionGet(currentCity.RegionId);
            currentCountry = await locations.countryGet(currentRegion.CountryId);
        } else {
            pageInit(true);
        }

        pageUpdate();

        cities = await locations.citiesGet();
        elements.companyCountrySelect.removeAttribute('disabled');
        elements.companyCityInput.removeAttribute('disabled');
        elements.tariffList.removeAttribute('disabled');
        elements.periodList.removeAttribute('disabled');

        // select tariff
        elements.tariffList.addEventListener('change', () => {
            const tariffList = elements.tariffList;
            tariffSelected = parseInt(tariffList[tariffList.selectedIndex].value);
            periodSelected = undefined;

            pageUpdate();

            const periodList = elements.periodList;
            periodSelected = parseInt(periodList[periodList.selectedIndex].value);
        });

        // select tariff period
        elements.periodList.addEventListener('change', () => {
            const selector = elements.periodList;
            periodSelected = parseInt(selector[selector.selectedIndex].value);
            pageUpdate();
        });
    }

    return {
        main: main,
        companyGet: companyGet,
        ownerGet: ownerGet,
        pageUpdate: pageUpdate
    }
})();